module.exports = __webpack_public_path__ + "static/media/solflaire.3ca08d70.png";